const breakpoint = {
  mobile: "max-width: 600px",
};

export default breakpoint;
